var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEncrypted = function SvgEncrypted(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 15h1.8q.226 0 .387-.187a.45.45 0 0 0 .113-.413l-.475-2.625a1.9 1.9 0 0 0 .787-.725Q14 10.574 14 10q0-.824-.588-1.413A1.93 1.93 0 0 0 12 8q-.825 0-1.412.587A1.93 1.93 0 0 0 10 10q0 .575.287 1.05.288.475.788.725L10.6 14.4a.45.45 0 0 0 .113.412.5.5 0 0 0 .387.188m.9 6.9a2 2 0 0 1-.625-.1Q8 20.676 6 17.637 4 14.6 4 11.1V6.375q0-.626.362-1.125.363-.5.938-.725l6-2.25a2.1 2.1 0 0 1 .7-.125q.35 0 .7.125l6 2.25q.575.225.938.725.362.5.362 1.125V11.1q0 3.5-2 6.538-2 3.037-5.375 4.162-.15.05-.3.075T12 21.9m0-2q2.6-.825 4.3-3.3t1.7-5.5V6.375l-6-2.25-6 2.25V11.1q0 3.025 1.7 5.5t4.3 3.3"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEncrypted);
export { ForwardRef as ReactComponent };